import React from 'react';
import DispatchNoteList from '../../../../pages/despatchNote/DispatchNoteList';

const DNInServiceProvider = ({ id }: { id?: string }) => {
  return id ? <DispatchNoteList independent={false} extraFilter={`customerId:${id}`} /> : null;
};

export default DNInServiceProvider;
